import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { DisputeProgressComponent } from './DisputeProgressComponent';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import {
  GenericAlphaNumericInput,
  GenericRadio,
} from 'web-ui-components/lib/data/capture';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import {
  CLAIM_TYPE,
  PAGE_CONTACT_DETAILS,
  PAGE_WHAT_DIDNT_YOU_RECEIVE,
} from '../../../constants/FraudAndDisputeConstants';
import { ValidationMessageTile } from 'web-ui-components/lib/layout/content';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import FraudAndDisputeStore from '../../../stores/FraudAndDisputeStore';
import FraudAndDisputeActionCreator from '../../../actions/FraudAndDisputeActionCreator';
import { isDecimal } from '../../../utils/FraudAndDisputeValidationUtils';
import AnalyticsUtil from '../../../utils/AnalyticsUtil';
import config from '../../../config';

export class ClaimAmount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      refundType: FraudAndDisputeStore.getRefundType(),
      displayValidationMessage: false,
      partialRefundAmount: FraudAndDisputeStore.getPartialRefundAmount(),
      displayPartialRefundAmountValidationMessage: false,
      partialRefundAmountValidationMessage: null,
    };
  }

  onContinueClick = () => {
    const { content, data, setPage } = this.props;
    const { refundType, partialRefundAmount } = this.state;
    const sanitisedAmount = Math.abs(data?.rawAmount);
    if (!refundType) {
      this.setState({ displayValidationMessage: true });
      return;
    }

    if (refundType === CLAIM_TYPE.FULL_REFUND) {
      this.setState({ displayValidationMessage: false });
      FraudAndDisputeActionCreator.setRefundType(refundType);
      setPage(PAGE_WHAT_DIDNT_YOU_RECEIVE);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_full_claim,
        config.analytics.analytics_action_button_click
      );
      return;
    }

    if (!partialRefundAmount) {
      this.setState({
        partialRefundAmountValidationMessage: content.partialRefundText,
        displayPartialRefundAmountValidationMessage: true,
      });
      return;
    }

    if (!isDecimal(partialRefundAmount)) {
      this.setState({
        partialRefundAmountValidationMessage:
          content.claimAmountValidationMessage3,
        displayPartialRefundAmountValidationMessage: true,
      });
      return;
    }

    if (
      isDecimal(partialRefundAmount) &&
      !parseFloat(partialRefundAmount) > 0
    ) {
      this.setState({
        partialRefundAmountValidationMessage: `${content.partialRefundAmountValidationMessage}${sanitisedAmount}`,
        displayPartialRefundAmountValidationMessage: true,
      });
      return;
    }

    if (parseFloat(partialRefundAmount) > sanitisedAmount) {
      this.setState({
        partialRefundAmountValidationMessage: `${content.partialRefundAmountValidationMessage}${sanitisedAmount}`,
        displayPartialRefundAmountValidationMessage: true,
      });
      return;
    }

    if (parseFloat(partialRefundAmount) <= sanitisedAmount) {
      this.setState({ displayPartialRefundAmountValidationMessage: false });
      FraudAndDisputeActionCreator.setRefundType(refundType);
      FraudAndDisputeActionCreator.setPartialRefundAmount(partialRefundAmount);
      setPage(PAGE_WHAT_DIDNT_YOU_RECEIVE);
      AnalyticsUtil.analyticAction(
        config.analytics.analytics_experience_activity,
        config.analytics.analytics_event_method_interacted,
        config.analytics.analytics_action_dispute_partial_claim,
        config.analytics.analytics_action_button_click
      );
      return;
    }
  };

  render() {
    const { content, setPage, data } = this.props;
    const {
      refundType,
      partialRefundAmount,
      displayValidationMessage,
      displayPartialRefundAmountValidationMessage,
      partialRefundAmountValidationMessage,
    } = this.state;
    const refundTypeItems = [
      {
        id: CLAIM_TYPE.FULL_REFUND,
        labelText: `${content.fullRefund} (£${Math.abs(data?.rawAmount)})`,
      },
      {
        id: CLAIM_TYPE.PARTIAL_REFUND,
        labelText: content.partialRefund,
      },
    ];

    return (
      <div>
        <ApplicationFormShell
          leftSidebar={
            <DisputeProgressComponent
              items={content.disputeProgressStepperItems}
              currentId="1"
            />
          }
        >
          <PageHeading>{content.howMuchAreYouClaiming}</PageHeading>
          <StandardBody>
            <strong>{content.howMuchAreYouClaimingDescriptionText}</strong>
          </StandardBody>
          <GenericRadio.StackedSet
            groupName="radio-group-claim-types"
            items={refundTypeItems}
            onChange={(id) => {
              this.setState({
                refundType: id,
                displayValidationMessage: '',
                displayPartialRefundAmountValidationMessage: '',
                partialRefundAmount: '',
              });
            }}
            selectedId={refundType}
          />
          {displayValidationMessage && !refundType && (
            <ValidationMessageTile
              data-test-id="genericFieldWrapper-validation-message"
              messageText={content.claimAmountValidationMessage1}
            />
          )}
          {refundType === CLAIM_TYPE.PARTIAL_REFUND && (
            <div className="web-ui-components">
              <GenericFieldWrapper
                titleText={content.partialRefundText}
                validationMessage={
                  displayPartialRefundAmountValidationMessage &&
                  partialRefundAmountValidationMessage
                }
              >
                <GenericAlphaNumericInput
                  id="partial-refund"
                  onChange={({ value }) => {
                    this.setState({ partialRefundAmount: value });
                  }}
                  value={partialRefundAmount}
                />
              </GenericFieldWrapper>
            </div>
          )}
          <div className="button-group">
            <NavigationButton.Secondary
              labelText={content.back}
              onClick={() => {
                setPage(PAGE_CONTACT_DETAILS);
              }}
            />
            <NavigationButton.Primary
              labelText={content.continueButtonText}
              onClick={this.onContinueClick}
            />
          </div>
        </ApplicationFormShell>
      </div>
    );
  }
}

ClaimAmount.propTypes = {
  content: PropTypes.object,
  setPage: PropTypes.func,
};
